export const messages = {
  header: {
    id: 'personalContacts.Header',
    defaultMessage: 'Personal Contacts',
  },
  label: {
    noContacts: {
      id: 'personalContacts.Label.NoContacts',
      defaultMessage: 'You have no personal contacts.',
    },
  },
  edit: {
    id: 'personalContacts.Edit',
    defaultMessage: 'Edit',
  },
  addContact: {
    id: 'personalContacts.AddContact',
    defaultMessage: 'Add Contact',
  },
  screenReader: {
    addContactLink: {
      id: 'personalContacts.ScreenReader.AddContactLink',
      defaultMessage: 'Add Contact link clicking takes you to add contact page',
    },
  },
};
